export const createEmailWithTemplate = (from, to, subject, templateId, variables) => {
    return {
        from:from,
        to:to,
        subject:subject,
        payload:{
            templateId:templateId,
            variables:variables
        }
    }
}

export const createEmail = (from, to, subject, body) => {
    return {
        from:from,
        to:to,
        subject:subject,
        body: body
    }
}


// WEBPACK FOOTER //
// ./src/platform/notifications/email/factory/emailFactory.js